import { Injectable } from '@angular/core';
import { isDevMode } from '@angular/core';
import { AppSettings } from '../literals/app-settings.literal';
import { environment } from '../../../environments/environment';

@Injectable()
export class UrlHelperService {

  constructor() { }

  getApiUrl(): string {

    var url = localStorage.getItem("redeployment_apiUrl");

    if (url != undefined && url != "undefined" && url != null && url.length > 0) {
      return url.toString();
    }

    return environment.apiUrl
  }

  setUrl(specifiedUrl: string): void {
    localStorage.setItem("redeployment_apiUrl", specifiedUrl);
  }
}
